taxInfoCtrl.$inject = [];

export default function taxInfoCtrl() {
    const vm = this;

}
